import {
  LAST_STEP,
  buildQuoteMailto,
  buildSummary,
  clampStep,
  countSummary,
  digitsOnly,
  stepMatches,
  validateClub,
  validateEmail,
  validateLeagueOrLink,
  validatePhone,
} from "./quote.js";
import { initHeroVideo } from "./heroVideo.js";
import { initScroll } from "./scroll.js";
import { initCopyButtons } from "./copy.js";

function initQuoteWizard() {
  const form = document.getElementById("wycenaForm");
  const back = document.getElementById("back");
  const next = document.getElementById("next");
  if (!form || !back || !next) return;

  const steps = document.querySelectorAll(".step");
  const bars = document.querySelectorAll(".bars div");
  const options = document.querySelectorAll(".opt");
  const counts = document.querySelectorAll(".cnt");
  const status = document.getElementById("formStatus");
  let step = 0;

  options.forEach((button) => {
    button.addEventListener("click", () => {
      const pressed = button.getAttribute("aria-pressed") === "true";
      button.setAttribute("aria-pressed", String(!pressed));
    });
  });

  const matchCount = document.getElementById("matchCount");
  const matchStepper = document.getElementById("matchStepper");

  matchCount.addEventListener("input", () => {
    matchCount.value = digitsOnly(matchCount.value);
  });
  matchStepper.querySelectorAll(".step-btn").forEach((button) => {
    button.addEventListener("click", () => {
      matchCount.value = String(stepMatches(matchCount.value, Number(button.dataset.delta)));
    });
  });

  counts.forEach((button) => {
    button.addEventListener("click", () => {
      counts.forEach((other) => other.setAttribute("aria-pressed", "false"));
      button.setAttribute("aria-pressed", "true");
      // Pole na liczbę meczów pokazujemy tylko przy „Kilka meczów”.
      const several = button.dataset.count === "kilka";
      matchStepper.hidden = !several;
      if (several) matchCount.focus();
    });
  });

  function currentSummary() {
    const keys = [...options]
      .filter((button) => button.getAttribute("aria-pressed") === "true")
      .map((button) => button.dataset.key);
    const count = document.querySelector('.cnt[aria-pressed="true"]');
    return buildSummary(keys, count ? countSummary(count.dataset.count, matchCount.value) : "");
  }

  function render() {
    steps.forEach((section) => {
      section.hidden = Number(section.dataset.step) !== step;
    });
    bars.forEach((bar, index) => bar.classList.toggle("on", index <= step));
    document.getElementById("stepNo").textContent = String(step + 1);
    back.style.visibility = step === 0 ? "hidden" : "visible";
    next.style.display = step === LAST_STEP ? "none" : "";
    if (step === LAST_STEP) {
      document.getElementById("summary").textContent = currentSummary();
    }
  }

  next.addEventListener("click", () => {
    step = clampStep(step + 1);
    render();
  });
  back.addEventListener("click", () => {
    step = clampStep(step - 1);
    render();
  });

  // Strona jest statyczna (bez backendu), więc zapytanie wysyłamy przez
  // program pocztowy odwiedzającego z gotowym tematem i treścią.
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const klub = form.elements.namedItem("klub").value;
    const rozgrywki = form.elements.namedItem("rozgrywki").value;
    const link = form.elements.namedItem("link").value;
    const telefon = form.elements.namedItem("telefon").value;
    const email = form.elements.namedItem("email").value;
    const error =
      validateClub(klub) ||
      validateLeagueOrLink(rozgrywki, link) ||
      validatePhone(telefon) ||
      validateEmail(email);
    if (error) {
      status.textContent = error;
      return;
    }
    status.textContent = "";
    window.location.href = buildQuoteMailto({
      klub,
      rozgrywki,
      link,
      telefon,
      email,
      zamowienie: currentSummary(),
    });
    status.textContent = "Otworzyliśmy Twoją pocztę — wyślij wiadomość, a oddzwonimy.";
  });

  render();
}

function init() {
  initScroll();
  initQuoteWizard();
  initHeroVideo();
  initCopyButtons();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
